import { Store } from 'utils';
import App from './app';

class ChatStore extends Store {

	getInitialState() {
		return {
			messages: [],
			days: [],
			lid: null,
			stand: null,
			chatNotificationsEnabled: null,
			chatHash: null,
		};
	}

	getMessages() {
		return this.getState().messages;
	}

	removeDuplicates(messages) {

		var index = [];

		messages.forEach((item) => {
			index[item.id] = item;
		});

		var items = [];

		index.forEach((item) => {
			items.push(item);
		});

		return items;
	}

	groupByDays(messages) {
		var days = [];

		messages.forEach((item) => {
			var df = App.formatShortDate(item.createdAt);
			days[df] = [];
		});

		messages.forEach((item) => {
			var df = App.formatShortDate(item.createdAt);
			days[df].push(item);
		});

		var items = [];

		for(var day in days) {
			var di = days[day];
			items.push({
				day: day,
				items: di
			});
		}

		return items;
	}

	onChatRoomChanged(state, data) {
		state.stand = data.stand;
		state.messages = [];
		state.days = [];
		state.lid = null;
		state.chatHash = null;
	}

	onMessagesChanged(state, data) {

		state.messages = this.removeDuplicates(data.messages);
		state.days = this.groupByDays(state.messages);
		state.stand = data.stand;

		var max = data.messages.reduce((value, item) => {
			if(item.id > value) {
				return item.id;
			} else {
				return value;
			}
		}, 0);

		state.lid = max;
	}

	onChatHashChanged(state, data)
	{
		state.chatHash = data.hash;
	}

	onChatNotificationChanged(state, data)
	{
		state.chatNotificationsEnabled = data.chatNotificationsEnabled;
	}

	onChatChanged(state, data) {
		state.messages = [];
		state.lid = null;
		state.stand = data.stand;
	}

	getMessages() {
		return this.getState().messages;
	}

	getMessagesGroupedByDay() {
		return this.getState().days;
	}

	getLastMessageId() {
		return this.getState().lid;
	}

	getStandSlug() {
		return this.getState().stand;
	}

	getChatNotificationsEnabled()
	{
		return this.getState().chatNotificationsEnabled;
	}

	getChatHash()
	{
		return this.getState().chatHash;
	}

}

const store = new ChatStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/chatstore.js